<template>
  <div   class="page-index">
    <h4 style="margin-top: 0.2rem" v-if="description !== 'group' ">{{description}}</h4>
    <div class="nav-div" v-if="showFilterBarFlag">
      <nav class="bar bar-nav merbar">
        <div class="list-block" style="margin-top: 0rem;margin-bottom: 0rem;">
          <ul>
            <li class="item-content">
              <div class="item-inner">
                <div class="item-title">为您找到<span style="color: #0a8ddf;">{{queryTotal.total}}</span>条结果</div>
                <div class="item-after" style="color: #0a8ddf;" v-if="!showFilterBarForKit"><a class="pull-right open-panel" @click="openshaxuan()">筛选</a></div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div style="height: 2.2rem;" v-if="this.$route.query.id === 5 || this.$route.query.id === 8 || this.$route.query.id === 7 || this.$route.query.id === 9 || this.$route.name === 'searchresults'"></div>
    <div>
      <div  class="merchsdiv"  v-for="(pro,index) in merchs"   >
        <div v-if="description === 'group'">
          <div class="item-link item-content" @click="clickMerchandise(pro)">
            <div>
              <div class="merchsdiv1"  style="margin-bottom: 0.3rem"  >
                <div class="merchsprice" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1">
                  ¥{{pro.priceMax}}
                  <del v-if="pro.cataloguePrice " style="color: grey;font-size: 0.7rem">¥{{pro.cataloguePrice}}</del>
                </div>
                <div class="merchsprice" v-else>
                  ¥{{pro.priceMin}}
                  <del v-if="pro.cataloguePrice " style="color: grey;font-size: 0.7rem">¥{{pro.cataloguePrice}}</del>
                </div>
                <span class="merchstitle">
                   <!--<span v-for="bpromotion in getbpromotions(pro)" :key="bpromotion.type">-->

                      <!--<span   v-if="bpromotion.type != 0" >-->
                         <!--<span style="position:relative;color: white;background-color: #0894ec; padding: 0.1px;"></span>-->
                        <!--<span style="font-size: 0.5rem;color: white;background-color: #0894ec;padding: 0.1rem;">{{bpromotion.typeName}}</span>-->
                       <!--</span>-->
                   <!--</span>-->
                  <span v-if="pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].description !== ''">
                        <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{pro.bpromotions[0].name}}</span>
                   </span>
                  <span v-if="pro.promotions && pro.promotions.length > 0 && pro.promotions[0].type !== 0  && pro.promotions[0].requiredCustomers === 0 && pro.promotions[0].description !== '' ">
                        <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{pro.promotions[0].name}}</span>
                   </span>
              <span v-if="pro._subTitleList && pro._subTitleList.length>0" v-for="subTitle in pro._subTitleList">
                        <span style="position:relative;color: white;background-color: #00469A; padding: 0.1px;"></span>
                        <span style="font-size: 0.5rem;color: white;background-color: #00469A;padding: 0.1rem;">{{subTitle.valueText}}</span></span>
              <span class="merchstitle2"  style="padding-left: 3px" v-if="pro._abstractList && pro._abstractList.length > 0" v-for="abstract in pro._abstractList">   <span v-if="abstract.columnName === 'TVInfo'">{{abstract.valueText.TLNo}}</span><span v-else>{{abstract.valueText}}</span></span>
               </span>
              </div>
              <span style="left:0; bottom:0;font-size:0.9rem;color: #3F3F3F;padding-left:0.1rem;font-weight: bold"
                    v-if="pro._titleList && pro._titleList.length > 0" v-for="title in pro._titleList">
                      <span v-if="title.columnName === 'TVInfo'">
                        {{title.valueText.TLNo}}</span>
                <span v-else>{{title.valueText}}</span>
          </span>
              <div style="margin-top: 10px">
                <span style="margin-left: 3px;font-size: small; color: #4479B4" v-if="pro._specificatList && pro._specificatList.length > 0" v-for="specificat in pro._specificatList">{{specificat.label}}: {{specificat.valueText}}</span>
              </div>
              <div v-if="pro.selfOperated === 0" style=" margin-top: 20px;">
                <span style="font-size: x-small;color: #003d8e">【第三方】</span>
              </div>
              <hr  v-if="pro.selfOperated === 1"/>
              <hr v-else style=" margin-top: 1px;" />
            </div>
          </div>


        </div>
        <div v-else>
          <div v-if="!pro.composite">
            <div class="item-link item-content" @click="clickMerchandise(pro)">
              <div>
                <div class="merchsdiv1"  style="margin-bottom: 0.3rem"  >
                  <div class="merchsprice" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1">
                    ¥{{pro.priceMax}}
                    <del v-if="pro.cataloguePrice" style="color: grey;font-size: 0.7rem">¥{{pro.cataloguePrice}}</del>
                  </div>
                  <div class="merchsprice" v-else>
                    ¥{{pro.priceMin}}
                    <del v-if="pro.cataloguePrice" style="color: grey;font-size: 0.7rem">¥{{pro.cataloguePrice}}</del>
                  </div>
                  <span class="merchstitle">

                   <!--<span v-for="bpromotion in getbpromotions(pro)" :key="bpromotion.type">-->

                      <!--<span   v-if="bpromotion.type != 0" >-->
                         <!--<span style="position:relative;color: white;background-color: #0894ec; padding: 0.1px;"></span>-->
                        <!--<span style="font-size: 0.5rem;color: white;background-color: #0894ec;padding: 0.1rem;">{{bpromotion.typeName}}</span>-->
                       <!--</span>-->
                   <!--</span>-->
                    <span v-if="pro.bpromotions && pro.bpromotions.length > 0  && pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].description !== ''">
                        <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{pro.bpromotions[0].name}}</span>
                   </span>
                  <span v-if="pro.promotions && pro.promotions.length > 0 && pro.promotions[0].type !== 0 && pro.promotions[0].requiredCustomers === 0 && pro.promotions[0].description !== '' ">
                        <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{pro.promotions[0].name}}</span>
                   </span>
              <span v-if="pro._subTitleList && pro._subTitleList.length>0" v-for="subTitle in pro._subTitleList">
                        <span style="position:relative;color: white;background-color: #00469A; padding: 0.1px;"></span>
                        <span style="font-size: 0.5rem;color: white;background-color: #00469A;padding: 0.1rem;" v-if="subTitle.valueText.length > 15">{{subTitle.valueText.substring(0,15)}}...</span>
                    <span style="font-size: 0.5rem;color: white;background-color: #00469A;padding: 0.1rem;" v-if="subTitle.valueText.length <= 15">{{subTitle.valueText}}</span>

                  </span>
              <span class="merchstitle2"  style="padding-left: 3px" v-if="pro._abstractList && pro._abstractList.length > 0" v-for="abstract in pro._abstractList">   <span v-if="abstract.columnName === 'TVInfo'">{{abstract.valueText.TLNo}}</span><span v-else>{{abstract.valueText}}</span></span>
               </span>
                </div>
                <span style="left:0; bottom:0;font-size:0.9rem;color: #3F3F3F;padding-left:0.1rem;font-weight: bold"
                      v-if="pro._titleList && pro._titleList.length > 0" v-for="title in pro._titleList">
                        <span v-if="title.columnName === 'TVInfo'">
                        {{title.valueText.TLNo}}</span>
                <span v-else>{{title.valueText}}</span>
          </span>
                <div v-if="pro.selfOperated === 0" style=" margin-top: 20px;">
                  <span style="font-size: x-small;color: #003d8e">【第三方】</span>
                </div>
                <hr  v-if="pro.selfOperated === 1"/>
                <hr  style=" margin-top: 1px;" v-else/>
              </div>
            </div>
          </div>
          <div v-if="pro.composite" >
            <a class="item-link item-content"   @click="setdatas(pro)">
              <div>
                <div class="merchsdiv1"  style="margin-bottom: 0.3rem"  >
                  <div class="merchsprice" v-if="pro.priceMin !== pro.priceMax">
                    ¥{{pro.priceMin}} ~ ¥{{pro.priceMax}}
                  </div>
                  <div class="merchsprice" v-else>
                    <span  v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1 ">
                        ¥{{pro.priceMax}}
                    </span>
                    <span  v-else>
                        ¥{{pro.priceMin}}
                    </span>
                  </div>
                  <span class="merchstitle">
                   <!--<span v-for="bpromotion in getbpromotions(pro)" :key="bpromotion.type">-->

                      <!--<span   v-if="bpromotion.type != 0" >-->
                         <!--<span style="position:relative;color: white;background-color: #0894ec; padding: 0.1px;"></span>-->
                        <!--<span style="font-size: 0.5rem;color: white;background-color: #0894ec;padding: 0.1rem;">{{bpromotion.typeName}}</span>-->
                       <!--</span>-->
                   <!--</span>-->
                    <span v-if="pro.bpromotions && pro.bpromotions.length > 0  && pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].description !== ''">
                        <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{pro.bpromotions[0].name}}</span>
                   </span>
                  <span v-if="pro.promotions && pro.promotions.length > 0  && pro.promotions[0].requiredCustomers === 0 &&  pro.promotions[0].type !== 0 && pro.promotions[0].description !== '' ">
                        <span style="font-size: 0.5rem;color: red;padding: 0.1rem;">{{pro.promotions[0].name}}</span>
                   </span>
              <span v-if="pro._subTitleList && pro._subTitleList.length>0" v-for="subTitle in pro._subTitleList">
                        <span style="position:relative;color: white;background-color: #00469A; padding: 0.1px;"></span>
                        <span style="font-size: 0.5rem;color: white;background-color: #00469A;padding: 0.1rem;">{{subTitle.valueText}}</span></span>
              <span class="merchstitle2"  style="padding-left: 3px" v-if="pro._abstractList && pro._abstractList.length > 0" v-for="abstract in pro._abstractList">   <span v-if="abstract.columnName === 'TVInfo'">{{abstract.valueText.TLNo}}</span><span v-else>{{abstract.valueText}}</span></span>
               </span>
                </div>
                <span style="left:0; bottom:0;font-size:0.9rem;color: #3F3F3F;padding-left:0.1rem;font-weight: bold"
                      v-if="pro._titleList && pro._titleList.length > 0" v-for="title in pro._titleList">
                    <span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span>
                    </span>
                <div v-if="pro.selfOperated === 0" style=" margin-top: 20px;">
                  <span style="font-size: x-small">【第三方】</span>
                </div>
                <hr  v-if="pro.selfOperated === 1"/>
                <hr  style=" margin-top: 1px;" v-else/>

              </div>
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import emkt from '../emkt.js'
  import {mapState, mapMutations} from 'vuex'
  export default {
    // 在 props 中声明获取父组件的数据通过 message 传过来
    props: ['merchList', 'description', 'showFilterBar', 'showFilterBarForKit', 'isFromSearch', 'proo', 'channel'],
    data () {
      return {
        baseurl: '/emktResources/resocurces/img/merchandise/',
        total: 0
      }
    },
    methods: {
      ...mapMutations([
        'ADD_CART_LIST', 'MERCHDISEGROUP_UPDATE'
      ]),
      addCartListForRecom (pro) {
        this.ADD_CART_LIST(pro)
        $.toast('加入购物车成功！')
      },
      setdatas (pro) {
        if (this.isFromSearch) {
          emkt.customerBehaviours.searchresults.click = {'time': Date.parse(new Date()), 'target': pro.merchandiseId, 'type': emkt.customerBehaviourType.clickMer}
        }
        var _self = this
        _self.MERCHDISEGROUP_UPDATE(pro.compositions)
        this.$router.push({path: '/promotion/Compositions'})
      },
      openshaxuan () {
        $.openPanel('#panel-right-demo')
      },
      getbpromotions (merchdise) {
        if (merchdise.bpromotions) {
          var bpromotions = merchdise.bpromotions
          var r = []
          var t = []
          for (var m = 0; m < bpromotions.length; m++) {
            if (t.indexOf(bpromotions[m].type) === -1) {
              r.push(bpromotions[m])
              t.push(bpromotions[m].type)
              // console.log(m + ' ' + bpromotions[m].type)
            }
          }
          return r
        }
      },
      clickMerchandise (pro) {
        var id = ''
        var cid = 0
        if (pro.categoryId === 20 && pro.findId) {
          id = pro.findId
        } else if (pro.categoryId === 20 && !pro.findId) {
          cid = 20
          id = pro.merchandiseId
        } else {
          id = pro.merchandiseId
        }
        if (this.isFromSearch) {
          emkt.customerBehaviours.searchresults.click = {'time': Date.parse(new Date()), 'target': id, 'type': emkt.customerBehaviourType.clickMer}
        }
        if (this.proo) {
          this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}, params: {pro: this.proo}})
        } else if (this.channel) {
          this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}, params: {channel: this.channel}})
        } else {
          if (cid === 20) {
            this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId, cid: 20}})
          } else {
            this.$router.push({name: 'finderMerchandises', query: {id: id, categoryId: pro.categoryId}})
          }
        }
      }
    },
    computed: {
      ...mapState([
        'queryTotal', 'sessionInfo'
      ]),
      merchs: function () {
        var newmerchList = []
        if (!this.merchList) {
          return newmerchList
        }
        newmerchList = this.merchList
//        for (var i = 0; i < newmerchList.length; i++) {
//          var tags = []
//          var merchandiseMeta = emkt.getEmktMetaData()
//          var tagsmap = merchandiseMeta.tagsMap
//          for (var j = 0; j < newmerchList[i].tagIds.length; j++) {
//            tags.push(tagsmap[newmerchList[i].tagIds[j]].tagLabel)
//          }
//          newmerchList.tags = tags
//          var bpromotions = newmerchList[i].bpromotions
//          var r = []
//          var t = []
//          for (var m = 0; m < bpromotions.length; m++) {
//            if (t.indexOf(bpromotions[m].type) === -1) {
//              r.push(bpromotions[m])
//              t.push(bpromotions[m].type)
//              console.log(m + ' ' + bpromotions[m].type)
//            }
//          }
//          newmerchList[i].bpromotions = r
//        }
        this.total = newmerchList.length
        return newmerchList
      },
      showFilterBarFlag () {
        let flag = true
        let src = this.$route.name
        if (src === 'home') {
          flag = false
        }
        if (!this.showFilterBar) {
          flag = false
        }
        return flag
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.merchsdiv {
  margin-top: 5px;
  margin-bottom:0px;
  margin-left: 10px;
  margin-right:10px
}
.merchsdiv1 {
  height: 35px ;
  position:relative;
  margin-top: 10px
}
.page-index{
  margin-top: 0px;
  overflow-x: hidden;
  background-color: white
  }
h4 {
  text-align:center ;
  color: #d94b73;
  margin-top: 0px;
  overflow-x: hidden;
  margin-bottom: 5px;
}
.merchsprice {
  float: right;
  margin-top: 42px;
  color: #4479B4
  }
.merchsprice1 {
  float: right;
  margin-top: 72px;
  color: #4479B4
}
  .merchstitle {
    position:absolute;
    left:0;
    top:0;
    border: #2ac845;
  }
 .merchstitle2 {
   font-size: small;
   color: black
 }
 .merchsdiscount {
   font-size: x-small;
   width:30px;color: white;
   background-color: #0597EA;
   margin-left: 3px;
   padding-left: 1px;
   padding-right: 1px;
 }
  hr {
    height:0.06rem;
    border:0rem;
    background-color:#B4B4B4;
    margin-top: 30px;
  }
  .tip-filter{
    margin-top: 0.5rem;
  }
  .left-class{
    float: left;
  }
  .right-class{
    float: right;
  }
  .merbar{
    background-color: #ffffff;
    height: 2.3rem;
  }
  .nav-div{
    height: 2.2rem;
    position: fixed;
    width: 100%;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// MerchandiseList.vue?171ccef6